module.exports = __webpack_public_path__ + "img/faq_ladies.8e4ffed8.jpg";